<template>
    <v-card>
      <v-card-title class="pl-4">
        <h3>Manage your simulation saves</h3>
      </v-card-title>
      <v-list outlined mandatory height="300px" class="ma-0 pa-0 overflow-y-auto">
        <v-progress-linear v-if="mainLoading" indeterminate color="teal darken-2" height="5px"></v-progress-linear>
        <v-list-item-group v-else mandatory v-model="model" active-class="border" color="indigo">
          <v-list-item @click="newSaveClick()">
            <v-list-item-icon>
              <v-icon v-text="'mdi-content-save'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'New Save ...'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="divider"></v-divider>
          <v-list-item v-for="(item, i) in items" :key="i" @click="menuActionClick(i, item)">
            <v-list-item-icon>
              <v-icon v-text="'mdi-cloud-upload'"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.saveName"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn @click="deleteItemEvent(i, item)" icon>
                <v-icon color="blue darken-4">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

        </v-list-item-group>
        <v-spacer></v-spacer>

      </v-list>

      <v-card-actions class="px-5">
        <v-btn width="100px" @click="cancelButton"> Cancel </v-btn>

        <v-text-field label="Save name" class="pl-15 pr-5" v-model="savename" :disabled="this.model!=0"></v-text-field>
        <v-btn width="100px" :disabled="this.savename == ''" @click="pressedSave()">
          {{ this.saveLabel }}
        </v-btn>
        <v-btn width="100px" :disabled="0 == this.model" @click="pressedLoad()"> Load </v-btn>
      </v-card-actions>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>Delete</v-card-title>
        <v-card-text>Are you sure that you want to delete "{{ this.itemNameToDelete }}" </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
          <v-btn color="primary" text @click="deleteItem()">Delete</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
  <v-dialog v-model="dialogUpdate" max-width="500px">
      <v-card>
        <v-card-title>Update</v-card-title>
        <v-card-text>Are you sure that you want to update "{{ this.savename }}"</v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="dialogUpdate = false">Close</v-btn>
          <v-btn color="primary" text @click="save()">Update</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
    </v-card>
</template>

<script>
export default {
  async mounted() {
    await this.requestSaves();
        this.newSaveClick();

  },
  methods: {
    async pressedSave() {
        if(this.model == 0){
            await this.save();
        }else{
            this.dialogUpdate = true;
        }
      
    },
    async save(){
        await this.$store.state.networkHandler.storeSimulationSave(this.savename, this.model > 0);
      await this.requestSaves(false);
      this.dialogUpdate = false;
    },
    pressedLoad() {
    this.$store.state.simulationEvents = this.items[this.model - 1].events;
    this.$emit("close")
    },
    newSaveClick() {
      this.savename = "";
      this.saveLabel = "Save";
    },
    deleteItemEvent(index, item) {
      this.indexToDelete = index;
      this.itemNameToDelete = item.saveName;

      this.dialogDelete = true;
    },

    menuActionClick(index, item) {
      this.savename = item.saveName;
      this.saveLabel = "Update";
    },
    cancelButton() {
      this.$emit("close")
    },
    async deleteItem() {
      await this.$store.state.networkHandler.deleteSimulationSave(this.itemNameToDelete);
      await this.requestSaves(false);
      this.dialogDelete = false;
    },

    async requestSaves(useLoading = true){
        if(useLoading){
            this.mainLoading = true;
        }

        var data = await this.$store.state.networkHandler.getAllSimulationSaves();
       this.items = data;
       this.mainLoading = false;

        this.model = 0;
        this.newSaveClick();
       
    },

    async openDialog() {
        await this.requestSaves();
        this.newSaveClick();

    },
  },
  data: () => ({
    savename: "",
    saveLabel: "Save",
    dialogDelete: false,
    dialogUpdate: false,
    itemNameToDelete: "",
    itemNameToUpdate: "",
    indexToDelete: 0,
    mainLoading: true,
    disableSaveButton: true,

    items: [],
    model: 0,
  }),
};
</script>

<style scoped>
.divider {
       border-width: 1px !important;
       border-color: rgba(55, 55, 55, 0.3) !important;
       height: 100%;
}

.btn {
  border: 1px solid #abb8f8 !important;
}

.btn {
  height: var(--simulation-button-height);
  width: var(--simulation-button-height);

  border: none;
  border-radius: 20%;
  background-color: var(--background-color);
}
</style>

<style scoped>
::-webkit-scrollbar {
  width: 10px;
}
</style>
